import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function Hero() {
  const scrollToPricing = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative pt-16 pb-20 lg:pt-24 lg:pb-32 overflow-hidden" data-id="element-64">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-65">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-66">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="flex flex-col items-start" data-id="element-67">
            <div className="inline-flex items-center rounded-full px-4 py-1.5 text-xs font-semibold text-brand-pink bg-brand-pink/10 border border-brand-pink/20 mb-6" data-id="element-68">
              PARA PROFESIONALES DE LA ESTÉTICA EN ARGENTINA
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-[64px] leading-[1.1] font-serif font-bold text-white mb-6 text-balance" data-id="element-69">
              Dejá de perseguir clientas y empezá a{' '}
              <span className="text-brand-pink italic" data-id="element-70">liderar</span> tu
              negocio.
            </h1>

            <p className="text-lg sm:text-xl text-gray-300 mb-8 max-w-xl" data-id="element-71">
              El sistema blindado para llenar tu agenda y escalar tus precios.
            </p>

            <ul className="space-y-4 mb-10" data-id="element-72">
              {['Atraé clientas que pagan lo que valés', 'Organizá tus finanzas y ganale a la inflación', 'Sistematizá tu gabinete para trabajar menos horas'].map((item, i) => <motion.li key={i} initial={{
              opacity: 0,
              x: -20
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              duration: 0.5,
              delay: 0.3 + i * 0.1
            }} className="flex items-center gap-3 text-gray-200" data-id="element-73">
                  <CheckCircle2 className="w-5 h-5 text-brand-pink shrink-0" data-id="element-74" />
                  <span data-id="element-75">{item}</span>
                </motion.li>)}
            </ul>

            <div className="w-full sm:w-auto flex flex-col items-center sm:items-start gap-3" data-id="element-76">
              <a href="#pricing" onClick={scrollToPricing} className="w-full sm:w-auto inline-flex items-center justify-center px-8 py-4 text-base sm:text-lg font-bold text-brand-black bg-brand-pink rounded-full hover:bg-brand-pink-deep hover:scale-105 transition-all duration-200 shadow-[0_0_30px_rgba(248,200,220,0.3)]" data-id="element-77">
                QUIERO ACCESO INSTANTÁNEO
              </a>
              <p className="text-xs text-gray-400 font-medium" data-id="element-78">
                Pago único · Descarga inmediata · Garantía 7 días
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative lg:ml-auto w-full max-w-lg mx-auto lg:max-w-none" data-id="element-79">
            {/* Pink Glow Background */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-brand-pink/20 blur-[100px] rounded-full pointer-events-none" data-id="element-80"></div>

            <div className="relative animate-float" data-id="element-81">
              <img src="https://cdn.magicpatterns.com/uploads/pRxD7QqzmXECtV51iHjRFf/heylloyd-image-1779601718801.png" alt="Megapack Depilación Total" className="w-full h-auto object-contain drop-shadow-2xl" data-id="element-82" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}